var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.pending,
          expression: "pending"
        }
      ]
    },
    [
      _vm.value
        ? [
            _c(
              "el-aside",
              { staticStyle: { "min-width": "20%" }, attrs: { width: "" } },
              [
                _c("el-input", {
                  attrs: {
                    clearable: "clearable",
                    placeholder: "Search",
                    "prefix-icon": "el-icon-search"
                  },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                }),
                _c(
                  "nav",
                  { staticClass: "flex-column nav nav-pills" },
                  [
                    _vm._l(_vm.searched, function(doc, i) {
                      return [
                        !_vm.groups.has(doc.group)
                          ? _c(
                              "span",
                              { staticClass: "disabled nav-item nav-link" },
                              [
                                _vm._v(
                                  _vm._s(
                                    void _vm.groups.add(doc.group) || doc.group
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-item nav-link",
                            attrs: { to: "/docs/" + doc.group + "/" + doc.path }
                          },
                          [_vm._v(_vm._s(doc.group) + "/" + _vm._s(doc.path))]
                        )
                      ]
                    }),
                    _vm.searched.length === 0
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "disabled font-italic nav-item nav-link"
                          },
                          [_vm._v("No matches found!")]
                        )
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            ),
            _c("page", [_vm._t("default")], 2)
          ]
        : _c("el-main", [
            _c("h1", [_vm._v("Network error")]),
            _c("p", [_vm._v("Could not get API information.")])
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0571d4cb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0571d4cb","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs.vue
// module id = 517
// module chunks = 0